import { Button, Col, Row } from 'antd';
import React from 'react';

const ContinueButton = ({ getLocalStorageData, stepHandler }) => {
  return (
    <Row>
      <Col span={24}>
        <Row className='text-center mt-50' justify='center'>
          <Col span={18}>
            <Button
              className={`cmt-button primary ${getLocalStorageData.goToTabs ? (stepHandler.disableContinueButton ? 'disabled' : '') : (getLocalStorageData.disableContinueButton ? 'disabled' : '')}`}
              type="primary"
              size='large'
              disabled={getLocalStorageData.goToTabs ? stepHandler.disableContinueButton : getLocalStorageData.disableContinueButton}
              block={true}
              onClick={getLocalStorageData.goToTabs ? stepHandler.continueButtonHandler : getLocalStorageData.continueButtonHandler}
              loading={getLocalStorageData.goToTabs ? stepHandler.loading : getLocalStorageData.loading}
            >
              {
                (!getLocalStorageData.goToTabs && getLocalStorageData.hasSurvey) ? `Comenzar examen` : (stepHandler.status === 'done' ? 'Finalizar' : 'Siguiente')
              }
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default ContinueButton;